/**
 * Title → rarity mapping. Used by the seat-title in the lobby, the
 * title pill on the profile, and the title selector dropdown so a
 * "Burnstile Master" reads at a glance against a "Tavern Regular".
 *
 * Rarity tiers (mirroring the broader cosmetic system):
 *   1 — common (bone)
 *   2 — rare (azure)
 *   3 — epic (violet)
 *   4 — legendary (gold)
 *
 * Mastery suffixes win automatically; everything else is hand-mapped.
 */

export type TitleRarity = 1 | 2 | 3 | 4;

export function titleRarity(title: string | null | undefined): TitleRarity {
  if (!title || title === 'Tavern Regular') return 1;
  if (title.endsWith(' Master')) return 4;
  if (title.endsWith(' Adept')) return 3;
  if (title.endsWith(' Apprentice')) return 2;
  switch (title) {
    case 'First Winner':       return 2;
    case 'Daily Visitor':       return 1;
    case 'Daily Devotee':       return 3;
    case 'Hearthkeeper':        return 4;
    case 'Streaker':            return 2;
    case 'Hot Streak':          return 1;
    case 'White Hot':           return 2;
    case 'Inferno':             return 4;
    case '100 Club':            return 1;
    case '1000 Club':           return 2;
    case '10K Club':            return 4;
    case 'Table Champion':      return 3;
    case 'Set Collector':       return 3;
    case 'Undefeated':          return 4;
    case 'MVP Magnet':          return 3;
    case 'MVP Spotlight':       return 1;
    case 'Stage Light':         return 4;
    case 'Tavern Veteran':      return 3;
    case 'First Drink':         return 1;
    case 'Regular':             return 1;
    case 'Veteran':             return 2;
    case 'Patron':              return 3;
    case 'Sampler':             return 2;
    case 'Round Hunter':        return 2;
    case 'Round King':          return 3;
    case 'Eclectic':            return 3;
    case 'Comeback Kid':        return 2;
    case 'Donut':               return 1;
    case 'Witching Hour':       return 3;
    case 'Dawnkeeper':          return 4;
    case 'Sweeper':             return 4;
    case 'Phoenix':             return 4;
    default:                    return 2;
  }
}

/** CSS class name for a title's rarity, used to color it consistently. */
export function titleRarityClass(title: string | null | undefined): string {
  return `title-rarity-${titleRarity(title)}`;
}
